import yieldPlot from "../../../../content/posts/blogs/2021/fastcat/yield.jsx";
import * as React from 'react';
export default {
  yieldPlot,
  React
};